<template>
  <div
    id="my-strictly-unique-vue-upload-multiple-image"
    style="display: flex; justify-content: center;"
  >
    <vue-upload-multiple-image
      :idUpload="`${imgUploadType}_${imgUploadIdx}`"
      :editUpload="`${imgUploadType}_${imgUploadIdx}_edit`"
      :data-images="images"
      :drag-text="textDrag"
      :browse-text="textBrowse"
      :primary-text="textPrimary"
      :mark-is-primary-text="textMarkIsPrimary"
      :popup-text="textPopup"
      :drop-text="textDrop"
      :show-primary="showPrimary"
      :show-edit="showEdit"
      :show-add="showAdd"
      :show-delete="showDelete"
      :max-image="maxImage"
      :disabled="disabled"
      @upload-success="uploadImageSuccess"
      @before-remove="beforeRemove"
      @edit-image="editImage"
    />
    <b-link v-if="useSaveBtnMethod">Save</b-link>
    <modal-delete :modal-id="modalDelete" />
  </div>
</template>

<script>
import VueUploadMultipleImage from "vue-upload-multiple-image";
import ModalDelete from "@/components/modals/modalDelete";

import firebase from "firebase";
export default {
  name: "ImageUpload",
  components: {
    ModalDelete,
    VueUploadMultipleImage
  },
  props: {
    imgUploadIdx: {
      type: Number,
      default: 0
    },
    imgUploadType: {
      type: String,
      default: "myIdUpload"
    },
    storagePath: {
      type: String,
      default: "publishing_cover_img"
    },
    maxImage: {
      type: Number,
      default: 1
    },
    showEdit: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    useSaveBtnMethod: {
      type: Boolean,
      default: false
    },
    textDrag: {
      type: String,
      default: "Upload or drag images"
    },
  },
  data() {
    return {
      textBrowse: "",
      textPrimary: "This is the primary image",
      textMarkIsPrimary: "",
      textPopup: "Upload the images",
      textDrop: "",
      accept: "image/gif,image/jpeg,image/png,image/bmp,image/jpg",
      showPrimary: false,
      showAdd: false,
      disabled: false,
      images: [],
      uploading: false,
      modalDelete: "modal-delete",
      formData: null,
      index: null,
      fileList: null
    };
  },
  methods: {
    uploadImageSuccess(formData, index, fileList) {
      //console.log('UploadImageAccess');

      this.formDate = formData;
      this.index = index;
      this.fileList = fileList;

      //console.log('data', formData, index, fileList);
      const file = fileList[0];

      let vm = this;
      this.uploadImageToStorage(file.path, file.name)
        .then(resp => {
          //console.log(`Image Uploaded ${resp}`);
          vm.$emit("img-uploaded-url", this.imgUploadIdx, resp);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {});
    },
    uploadImageToStorage(imgDataUrl, fileName) {
      return new Promise((res, rej) => {
        let result = "";
        var characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var charactersLength = characters.length;
        for (var i = 0; i < 15; i++) {
          result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
          );
        }
        const timeStamp = new Date().valueOf();

        var storageRef = firebase
          .storage()
          .ref(`${this.storagePath}/${fileName}_${result}_${timeStamp}`);

        var metadata = {
          contentType: "image/jpeg"
        };

        var uploadTask = storageRef.putString(imgDataUrl, "data_url");

        uploadTask.on(
          "state_changed",
          snapshot => {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            //console.log(`Upload is ${progress}% done`);
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                //console.log("Upload is paused");
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                //console.log("Upload is running");
                break;
            }
          },
          error => {
            rej(error);
            //console.log("Error uploading image: ", error);
          },
          () => {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(downloadURL => {
                res(downloadURL);
              })
              .catch(error => {
                rej(error);
                //console.log("Error uploading image: ", error);
              });
          }
        );
      });
    },
    beforeRemove(index, done, fileList) {
      //console.log('index', index, fileList);

      this.$bvModal.show(this.modalDeleteRef);
      /*var r = confirm("remove image");
      if (r == true) {
        done()
      }*/
      //this.$emit("remove")
    },
    editImage(formData, index, fileList) {
      //console.log('edit data', formData, index, fileList)
    },
    async handleUploadImage() {
      this.uploading = true;

      await this.images.forEach(imgDataUrl => {
        const imgURLS = [];
        //console.log('imgDataUrl => ',imgDataUrl);
        this.$emit("img-urls", imgURLS);

        this.uploadImageToStorage(imgDataUrl)
          .then(imgURL => {
            //Save in array
            imgURLS.push(imgURL);

            console.log("imgDataUrl => ", imgDataUrl);
            if (imgURLS.length === this.images.length) {
              this.uploading = false;
              this.$emit("img-urls", imgURLS);
            }
          })
          .catch(e => {
            this.uploading = false;
          });
      });

      return true; //imgURLS;
    },
    oldAddPublishingCoverImage(idx, url) {
      const updates = { imgURL: url };
      const payload = {
        id: this.publishing.id,
        updates: updates
      };

      this.$store.dispatch("user/updatePublishing", payload).then(res => {
        if (res) {
          this.$bvModal.hide(this.publishingModal);
          this.resetForm();
          this.getPublishings();
          this.$store.dispatch("user/showNotification", {
            title: "Publishings Updated Successfully",
            description: "Awesome",
            variant: "success"
          });
        }
      });
    }
  }
};
</script>

<style scoped>
#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
